import React from "react";
import CustomModal from "./CustomModal";
import { delete_accnt, delete_icon, share_img_delete } from "../../assets";
import { LoadingButton } from "../header/form";

const DeleteModal = ({
  show,
  handleClose,
  deleteAccountHandler,
  loading,
  text = "",
}) => {
  return (
    <>
      <CustomModal
        show={show}
        handleClose={handleClose}
        className={"deleteModal"}
      >
        <div className="delete_modal">
          <div className="delete_accnt_btn">
            {/* <img src={share_img_delete} /> */}
            <img src={delete_icon} />
          </div>

          <div className="delete_accnt_title">
            {!text && (
              <h3>
                Are you sure you want to <br /> delete your account?
              </h3>
            )}
            {text && <h3>{text}</h3>}
          </div>

          <div className="button_wrap">
            <LoadingButton
              loading={loading}
              type="button"
              className="button"
              onClick={deleteAccountHandler}
            >
              Yes
            </LoadingButton>
            <button
              type="button"
              className="button light"
              onClick={handleClose}
            >
              No
            </button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DeleteModal;
